import { useCallback } from 'react'
import MarkdownRender from 'LuxKit/MarkdownRender'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import FlashHotelAvailabilityButton from '../FlashHotelAvailabilityButton'
import OfferPageIntroInclusions from 'components/OfferPage/OfferPageIntroInclusions'
import Divider from 'LuxKit/Divider'
import Group from 'components/utils/Group'
import SoftOfferPageWalledGarden from 'components/Common/SoftOfferPageWalledGarden'
import { useIntl } from 'react-intl'

interface Props {
  additionalDescriptionMarkdown: string
  tileInclusions?: Array<App.OfferInclusion>
}

function FlashHotelInclusionsModal(props: Props) {
  const {
    additionalDescriptionMarkdown,
    tileInclusions,
  } = props

  const intl = useIntl()
  const { resolve } = useModalElementContext()
  const onCTAClick = useCallback(() => resolve(), [resolve])
  const hasTileInclusions = !!tileInclusions?.length
  const hasAdditionalDescription = !!additionalDescriptionMarkdown

  return (
    <ModalBase>
      <ModalHeader
        title={intl.formatMessage({
          id: 'zg_x7PimH8896Rnmnr-m',
          defaultMessage: 'Inclusions',
          description: 'Title for inclusions modal dialog window',
        })}
      />
      <ModalBody>
        <ModalContent>
          <VerticalSpacer gap={24}>
            {hasTileInclusions && (
              <Group direction="vertical" gap={8}>
                <HeadingTextBlock variant="heading4">
                  {intl.formatMessage({
                    id: 'YvEW3hh5xi4-UyzKYf4e',
                    defaultMessage: 'Your handpicked inclusions',
                    description: 'Heading for handpicked inclusions in the offer inclusions section',
                  })}
                </HeadingTextBlock>
                <OfferPageIntroInclusions tileInclusionsList={tileInclusions} />
              </Group>
            )}
            {hasTileInclusions && hasAdditionalDescription && <Divider kind="secondary" />}
            {hasAdditionalDescription && (
              <MarkdownRender type="compact" content={additionalDescriptionMarkdown} />
            )}
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
      <SoftOfferPageWalledGarden>
        <ModalFooter>
          <FlashHotelAvailabilityButton onClick={onCTAClick} />
        </ModalFooter>
      </SoftOfferPageWalledGarden>
    </ModalBase>
  )
}

export default FlashHotelInclusionsModal
